var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.978271,
    y: 1,
    width: 35,
    height: 35,
    rx: 7.5,
    fill: "#F0F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9382 12.5C28.1682 12.85 27.3382 13.08 26.4782 13.19C27.3582 12.66 28.0382 11.82 28.3582 10.81C27.5282 11.31 26.6082 11.66 25.6382 11.86C24.8482 11 23.7382 10.5 22.4782 10.5C20.1283 10.5 18.2082 12.42 18.2082 14.79C18.2082 15.13 18.2483 15.46 18.3182 15.77C14.7582 15.59 11.5882 13.88 9.47825 11.29C9.10825 11.92 8.89825 12.66 8.89825 13.44C8.89825 14.93 9.64825 16.25 10.8082 17C10.0982 17 9.43825 16.8 8.85825 16.5V16.53C8.85825 18.61 10.3382 20.35 12.2982 20.74C11.669 20.9122 11.0083 20.9362 10.3682 20.81C10.6399 21.6625 11.1718 22.4084 11.8893 22.9429C12.6067 23.4775 13.4737 23.7737 14.3682 23.79C12.8519 24.9904 10.9722 25.6393 9.03825 25.63C8.69825 25.63 8.35825 25.61 8.01825 25.57C9.91825 26.79 12.1782 27.5 14.5982 27.5C22.4782 27.5 26.8083 20.96 26.8083 15.29C26.8083 15.1 26.8082 14.92 26.7982 14.73C27.6382 14.13 28.3582 13.37 28.9382 12.5Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.978271,
    y: 1,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "#ECECEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.913ad1ef56d4a3fb495e9eff9ff73658.svg";
export { ForwardRef as ReactComponent };